<template>
  <div class="toku-autodebit-banner" data-testid="toku-autodebit-banner" @click="handleClick">
    <img
      class="toku-autodebit-banner__icon"
      src="@/assets/icons/toku_autodebit_icon.svg"
      width="24"
      height="24"
      alt=""
      aria-hidden="true"
    />

    <div class="toku-autodebit-banner__copy">
      <span class="toku-autodebit-banner__title">{{ t("TokuAutodebit-Banner-Title") }}</span>
      <span class="toku-autodebit-banner__subtitle">{{ t("TokuAutodebit-Banner-Subtitle") }}</span>
    </div>

    <div class="toku-autodebit-banner__cta" aria-hidden="true">
      <img
        src="@/assets/icons/toku_autodebit_chevron.svg"
        width="12"
        height="20"
        alt=""
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "TokuAutodebitBanner",
  props: {
    url: { type: String, required: true },
  },
  setup(props) {
    const { t } = useI18n();

    const handleClick = () => {
      window.open(props.url, "_blank", "noopener,noreferrer");
    };

    return { t, handleClick };
  },
});
</script>

<style scoped>
.toku-autodebit-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 71px;
  padding: 0 0 0 16px;
  margin-bottom: 16px;
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  background: #e1f8ff;
  border: 1px solid #0387a6;
  box-sizing: border-box;
}

.toku-autodebit-banner__icon {
  flex-shrink: 0;
}

.toku-autodebit-banner__copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.toku-autodebit-banner__title {
  font-size: 14px;
  font-weight: 600;
  color: #302727;
  line-height: 17px;
}

.toku-autodebit-banner__subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #342929;
  line-height: 16px;
}

.toku-autodebit-banner__cta {
  flex-shrink: 0;
  width: 45px;
  height: 71px;
  background: #0891b2;
  border-bottom-left-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
